(function () {
  'use strict';

  angular
    .module('app.account-create', [])

    /* @ngInject */
    .controller('accountCreateCtrl', ["$scope", "$rootScope", "$timeout", "$location", "HttpService", "AppService", "ModalService", "LogService", "Routes", "DefaultLocalization", function ($scope, $rootScope, $timeout, $location, HttpService, AppService, ModalService, LogService, Routes, DefaultLocalization) {
      var ctrl = this,
        unwatch,
        dropzone;

      ctrl.formData = {
        RememberMe: false,
        CustomerPro: false,
        errors: {},
        returnUrl: '/Account',
        Address: ' ',
        AddressApartment: ' ',
        AddressBuilding: ' ',
        AddressLocality: ' ',
        Phone: ' ',
        MobilePhone: ' ',
        ProfilePicture: null
      };

      $timeout(function () {
        ctrl.formData.Address = '';
        ctrl.formData.AddressApartment = '';
        ctrl.formData.AddressBuilding = '';
        ctrl.formData.AddressLocality = '';
        ctrl.formData.Phone = '';
        ctrl.formData.MobilePhone = '';
      });

      ctrl.focus = function () {
        ctrl.formData.errors.Global = null;
      };

      ctrl.dzOptions = {
        maxFiles: 1,
        paramName: 'files',
        acceptedFiles: 'image/jpeg, images/jpg, image/png, image/gif',
        renameFilename: function (name) {
          return new Date().getTime() + '_!_' + name;
        }
      };

      ctrl.dzCallbacks = {
        addedfile: function () {
          ModalService.close();
        },
        complete: function (file) {
          if (file.name !== ctrl.tmpFileName) {
            ModalService.show(
              '/Template/Modal/ModalUploadCrop',
              {
                ctrlFrom: ctrl,
                name: file.name,
                serverName: file.serverName,
                tmpId: new Date().getTime()
              },
              null,
              'uploadCropModalCtrl'
            );
          }
          ctrl.tmpFileName = '';
          dropzone.options.url = '/Upload/upload';
        },
        success: function (file) {
          ctrl.formData.ProfilePicture = {
            Name: file.name,
            ServerName: file.serverName
          };
        },
        removedfile: function () {
          if (ctrl.tmpFileName === '') {
            ctrl.formData.ProfilePicture = null;
            dropzone.options.url = '/Upload/upload';
          }
        }
      };

      ctrl.deleteTmpFile = function (serverName) {
        HttpService.get({
          url: '/Delete/upload/' + serverName,
          cache: false
        })
        .then(function () {
        })
        .catch(function (error) {
          console.error(error);
        });
      };

      $scope.$on('dropzone', function (event, object) {
        dropzone = object;
        dropzone.options.url = '/Upload/upload';
      });

      ctrl.submit = function () {

        ctrl.formData.ConfirmEmail = ctrl.formData.Email;

        $rootScope.$broadcast('showPageLoader', true);

        ctrl.formData.errors = {};

        HttpService.post({
          url: '/AccountCreate',
          data: ctrl.formData
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                AppService.getParams(true)
                  .then(function () {
                    $rootScope.$broadcast('login');
                    if (LogService.redirect) {
                      if (LogService.redirect.url) $location.path(LogService.redirect.url).replace();
                      if (LogService.redirect.action) LogService.redirect.action();
                      LogService.redirect = null;
                    } else {
                      $location.path('/' + Routes.filter(function (route) { return route.Name === 'AccountHome'; })[0][DefaultLocalization].URL).replace();
                    }
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              } else {
                _.each(response.errors, function (error, key) {
                  if (key === 'Global') {
                    ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                  }
                });
                $rootScope.$broadcast('showPageLoader', false);
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });

      };

      ctrl.$onInit = function () {
        ctrl.dzMethods = {};
      };

      ctrl.$onDestroy = function () {
        if (typeof unwatch !== 'undefined') {
          unwatch();
        }
      };

      unwatch = $scope.$watch('formData.CustomerPro', function (value) {
        if (!value) {
          ctrl.formData.IDCompanyTitle = '';
          ctrl.formData.Company = '';
          ctrl.formData.Siret = '';
          ctrl.formData.IDActivity = '';
          ctrl.formData.IDActivityDomain = '';
          $('#IDCompanyTitle').selectpicker('val', '');
        }
        $timeout(function () {
          ctrl.formCreate.$resetValidation();
        });
      });

      ctrl.toggleCustomerPro = function (event) {
        if (event.which === 13) {
          event.preventDefault();
          ctrl.formData.CustomerPro = !ctrl.formData.CustomerPro;
        }
      };
    }])

    /* @ngInject */
    .directive('accountActivities', function () {
      return {
        restrict: 'E',
        bindToController: {
          activitiesJson: '<',
          formData: '='
        },
        controllerAs: 'activitiesCtrl',
        /* @ngInject */
        controller: ["$element", "$timeout", function ($element, $timeout) {
          var ctrl = this;

          ctrl.$onInit = function () {
            refreshSelects();
          };

          ctrl.initActivity = function (IDActivity) {
            $timeout(function () {
              ctrl.formData.IDActivity = IDActivity.toString();

              ctrl.activities = _.find(ctrl.activitiesJson, {
                Activities: [{
                  IDActivity: Number(ctrl.formData.IDActivity)
                }]
              });

              ctrl.formData.IDActivityDomain = ctrl.activities.IDActivityDomain.toString();

              refreshSelects();
            });

          };

          ctrl.domainSelected = function () {
            if (ctrl.formData.IDActivityDomain) {
              ctrl.activities = _.find(ctrl.activitiesJson, { IDActivityDomain: Number(ctrl.formData.IDActivityDomain) });
              refreshSelects();
            }
          };

          function refreshSelects() {
            setTimeout(function () {
              $element.find('select').each(function (index, el) {
                $(el).selectpicker('refresh');
              });
            });
          }
        }]
      };
    });

})();
